import { SparkleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Ai = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <SparkleIcon size={Sizes[size]} color={fill} {...rest} />;
};

Ai.displayName = 'Ai';
